// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_flow_target_binding.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { ConnectorRef } from "../../app/v1/connector";
import { Any } from "../../../../google/protobuf/any";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask
 */
export interface PasswordPushFlowTargetBindingExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingRef
 */
export interface PasswordPushFlowTargetBindingRef {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBinding
 */
export interface PasswordPushFlowTargetBinding {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_path = 4;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string connector_path = 5;
     */
    connectorPath: string;
}
// ====== List ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListRequest
 */
export interface PasswordPushFlowTargetBindingServiceListRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask = 2;
     */
    expandMask?: PasswordPushFlowTargetBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListResponse
 */
export interface PasswordPushFlowTargetBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list = 1;
     */
    list: PasswordPushFlowTargetBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
// ====== Mutate ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateRequest
 */
export interface PasswordPushFlowTargetBindingServiceMutateRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorRef refs = 2;
     */
    refs: ConnectorRef[];
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask expand_mask = 4;
     */
    expandMask?: PasswordPushFlowTargetBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateResponse
 */
export interface PasswordPushFlowTargetBindingServiceMutateResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushFlowTargetBinding list = 1;
     */
    list: PasswordPushFlowTargetBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
// ====== Delete ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteRequest
 */
export interface PasswordPushFlowTargetBindingServiceDeleteRequest {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteResponse
 */
export interface PasswordPushFlowTargetBindingServiceDeleteResponse {
    /**
     * @generated from protobuf field: string password_push_flow_id = 1;
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3;
     */
    connectorId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingExpandMask$Type extends MessageType<PasswordPushFlowTargetBindingExpandMask> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "connector_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingExpandMask
 */
export const PasswordPushFlowTargetBindingExpandMask = new PasswordPushFlowTargetBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingRef$Type extends MessageType<PasswordPushFlowTargetBindingRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingRef", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingRef
 */
export const PasswordPushFlowTargetBindingRef = new PasswordPushFlowTargetBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBinding$Type extends MessageType<PasswordPushFlowTargetBinding> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBinding", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBinding
 */
export const PasswordPushFlowTargetBinding = new PasswordPushFlowTargetBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceListRequest$Type extends MessageType<PasswordPushFlowTargetBindingServiceListRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => PasswordPushFlowTargetBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListRequest
 */
export const PasswordPushFlowTargetBindingServiceListRequest = new PasswordPushFlowTargetBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceListResponse$Type extends MessageType<PasswordPushFlowTargetBindingServiceListResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlowTargetBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceListResponse
 */
export const PasswordPushFlowTargetBindingServiceListResponse = new PasswordPushFlowTargetBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceMutateRequest$Type extends MessageType<PasswordPushFlowTargetBindingServiceMutateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => PasswordPushFlowTargetBindingExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateRequest
 */
export const PasswordPushFlowTargetBindingServiceMutateRequest = new PasswordPushFlowTargetBindingServiceMutateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceMutateResponse$Type extends MessageType<PasswordPushFlowTargetBindingServiceMutateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushFlowTargetBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceMutateResponse
 */
export const PasswordPushFlowTargetBindingServiceMutateResponse = new PasswordPushFlowTargetBindingServiceMutateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceDeleteRequest$Type extends MessageType<PasswordPushFlowTargetBindingServiceDeleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteRequest", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteRequest
 */
export const PasswordPushFlowTargetBindingServiceDeleteRequest = new PasswordPushFlowTargetBindingServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowTargetBindingServiceDeleteResponse$Type extends MessageType<PasswordPushFlowTargetBindingServiceDeleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteResponse", [
            { no: 1, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowTargetBindingServiceDeleteResponse
 */
export const PasswordPushFlowTargetBindingServiceDeleteResponse = new PasswordPushFlowTargetBindingServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushFlowTargetBindingService
 */
export const PasswordPushFlowTargetBindingService = new ServiceType("c1.api.password_push.v1.PasswordPushFlowTargetBindingService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowTargetBindingServiceListRequest, O: PasswordPushFlowTargetBindingServiceListResponse },
    { name: "Mutate", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowTargetBindingServiceMutateRequest, O: PasswordPushFlowTargetBindingServiceMutateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowTargetBindingServiceDeleteRequest, O: PasswordPushFlowTargetBindingServiceDeleteResponse }
]);
